import { useRef, useEffect } from 'react';

export function useUIScroller<T>(items: T[]) {
  const scrollHeightRef = useRef(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      const el = scrollRef.current;
      const scrollHeight = el.scrollHeight;
      if (scrollHeight !== scrollHeightRef.current) {
        el.scrollTop = scrollHeight;
        scrollHeightRef.current = scrollHeight;
      }
    }
  }, [items]);

  return { scrollRef };
}
